'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './video-card.module.scss'

interface VideoCardProps extends HTMLProps<HTMLDivElement> {
  code: string
}

/**
 *
 * @param code - код разметки embedded виджета для вставки (iframe)
 * @param className
 * @constructor
 */
export const VideoCard = ({ code, className }: VideoCardProps) => {
  const { ref: innerRef, animate } = useAppearance()

  if (!code) return null

  return (
    <motion.section
      className={clsx(style.container, className)}
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
    >
      <div className={style.iframe} dangerouslySetInnerHTML={{ __html: code }} />
    </motion.section>
  )
}
